export enum HeaderTitles {
  LOGO_TEXT = 'Modernacasa.es',
  SLOGAN_TEXT = 'Building the<br>future together',
  PARTNER_BUTTON = 'Become a Partner',
  HOW_WE_WORK_BUTTON = 'How we work',
  CLIENT_BUTTON = 'Become a Client',
  HEADER_DESCRIPTION = 'Our company is engaged in providing comprehensive services for your future or current home. Repair, installation, design, consulting, restoration and many other services. From the foundation to the roof, from the gate to the door of your home, from solar panels to the smart home system, from the exterior to the interior, from building a villa for yourself to building a house for rent.  We do everything to enliven the space, transform cold walls into a cozy home, make this place truly comfortable, functional and cost-effective.',
}
